// extracted by mini-css-extract-plugin
export default {"dark":"CardHeaderPage_dark__Faz3n","App":"CardHeaderPage_App__ecnwu","container":"CardHeaderPage_container__5lKqI"};